import { Component, Inject, InjectReactive, Prop, PropSync, VModel, Vue, Watch } from "vue-property-decorator";
import Vorfallmanagement from "../api/Vorfallmanagement";
import { DateHelpers } from "@/helper/global-helper";
//@ts-ignore
import * as pickerlanguages from "vuejs-datepicker/dist/locale/index.js";
import { BenutzerInfo } from "@/Benutzer";

class SubTabBaseVfmt extends Vue {
  @Inject() public TabIndex!: string | number;
  @Prop() public SubTabIndex!: string | number;
  @Prop({ default: false }) readonly disabled!: boolean;

  @VModel() public vorfall!: Vorfallmanagement.Vorfall;

  @PropSync("hasChanged") public internalChanged!: boolean;

  @Prop() vorfallClone!: Vorfallmanagement.Vorfall;

  @InjectReactive("listen") readonly listen!: Vorfallmanagement.Listen | null;
  @InjectReactive("aktiverBenutzer") readonly aktiverBenutzer!: BenutzerInfo;

  public relevantProperties: (keyof Vorfallmanagement.Vorfall)[] = [];

  get relevantPropertiesObj() {
    if (this.vorfall) {
      return this.relevantProperties.reduce((obj, key) => ({ ...obj, [key]: this.vorfall[key] }), {});
    } else return null;
  }

  public get relevantValuesChanged() {
    if (this.vorfallClone && this.relevantProperties) {
      const changed = this.relevantProperties.filter((c) => {
        const orig = this.vorfall[c];
        const clone = this.vorfallClone[c];

        if (typeof orig !== typeof clone || (typeof orig !== "object" && typeof clone !== "object")) {
          return this.vorfall[c] !== this.vorfallClone[c];
        } else if (typeof orig === "object" && typeof clone === "object") {
          if (Vorfallmanagement.Utility.areAllValuesDates(orig, clone)) {
            return Vorfallmanagement.Utility.areDatesEqual(orig, clone);
          }
        }
        return this.vorfall[c] !== this.vorfallClone[c];
      });
      return changed.length > 0;
    } else {
      return false;
    }
  }

  @Watch("relevantValuesChanged", { deep: true })
  updateHasChanged(n: any, p?: any) {
    if (n !== p) {
      this.internalChanged = this.relevantValuesChanged;
    }
  }

  dateFormatter(date: Date) {
    return DateHelpers.PickerFormatter(date);
  }

  get dplang(): any {
    return this.$i18n.locale.toString().toLowerCase() == "de" ? pickerlanguages.de : pickerlanguages.en;
  }
}

export default SubTabBaseVfmt;
